module.exports = __webpack_public_path__ + "media/images/admin/dropzone/trash-0790c9dfb58430c4a9e6e0abd354f8a8.png";